import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { SharedModule } from "../../shared/shared.module";

@Component({
  selector: "app-logout",
  imports: [SharedModule],
  templateUrl: "./logout.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./logout.component.scss",
})
export class LogoutComponent implements OnInit, OnDestroy {
  // Delay before redirecting to /login, in ms. 0 = redirect immediately.
  // Set to e.g. 3000 to show the logout page briefly before redirecting.
  private readonly redirectDelayMs = 0;
  private redirectTimeout?: ReturnType<typeof setTimeout>;

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.clearSession();
    if (this.redirectDelayMs > 0) {
      this.redirectTimeout = setTimeout(
        () => void this.router.navigate(["/login"]),
        this.redirectDelayMs,
      );
    } else {
      void this.router.navigate(["/login"]);
    }
  }

  clearSession() {
    sessionStorage.clear();
    // Keep user-defined settings in local storage after logout — only session data is cleared.
  }

  ngOnDestroy(): void {
    clearTimeout(this.redirectTimeout);
  }
}
